// Client-side mirror of the SQL public.compute_age_range(date) brackets. Used
// only for the owner's own live "will display to others as..." preview while
// they edit their birthdate — every other group member gets age_range straight
// from get_group_name_profiles(), so the raw date never reaches their client.
//
// computeAgeYears() is the shared integer-age core: computeAgeRange() maps it to
// a bracket string, and isAtLeast18() is the signup age gate (see UserPrompt.js).
//
// Keep the brackets here in exact lockstep with the SQL function in
// supabase/migrations/20260901160043_add_name_profiles.sql.
//
// "Now" is read in UTC (getUTCFullYear/Month/Date), matching Postgres
// current_date on the Supabase project (session TZ = UTC). This is deliberate,
// not a bug: it keeps the client age gate in lockstep with the SQL
// compute_age_range() and a future server-side age check, and it errs toward
// rejecting a user who is almost-18 in their local timezone rather than
// admitting them. Do not switch this to local time.
export function computeAgeYears(birthdate) {
  if (!birthdate) return null;

  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(birthdate));
  if (!match) return null;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);

  const today = new Date();
  let years = today.getUTCFullYear() - year;
  const monthDiff = today.getUTCMonth() + 1 - month;
  if (monthDiff < 0 || (monthDiff === 0 && today.getUTCDate() < day)) {
    years -= 1;
  }

  if (years < 0) return null;
  return years;
}

export function computeAgeRange(birthdate) {
  const years = computeAgeYears(birthdate);
  if (years == null) return null;
  if (years < 1) return "Newborn (0-1)";
  if (years < 4) return "Toddler (1-3)";
  if (years < 10) return "Child (4-9)";
  if (years < 13) return "Pre-teen (10-12)";
  if (years < 18) return "Teen (13-17)";
  if (years < 25) return "18-24";
  if (years < 35) return "25-34";
  if (years < 45) return "35-44";
  if (years < 55) return "45-54";
  if (years < 65) return "55-64";
  return "65+";
}

export function isAtLeast18(birthdate) {
  const y = computeAgeYears(birthdate);
  return y != null && y >= 18;
}
